export default __webpack_public_path__ + "static/media/wake.77951601.png";